
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"},"content":"<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M20.5 4L25 8.52V26a2 2 0 01-2 2H9a2 2 0 01-2-2V6a2 2 0 012-2h11.5z\" fill=\"#F5455C\"/><path d=\"M20.5 4.002v3.501a1 1 0 001 1H25l-4.5-4.5z\" fill=\"#FFF\" opacity=\".5\"/><g fill=\"#FFF\"><path d=\"M15.55 16.748h4.5c0 2.468-2.031 4.5-4.5 4.5s-4.5-2.032-4.5-4.5c0-2.469 2.031-4.5 4.5-4.5v4.5z\"/><path d=\"M16.3 16v-4.5a4.502 4.502 0 014.5 4.5h-4.5z\"/></g></g>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
